module.exports = __webpack_public_path__ + "img/CS_1_Inspection_train_whole_2.17be278f.png";